import React from 'react';
import { FooterSection } from '../types';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';
import { Logo, MasterCard, VisaCard } from '../images';
  
const Footer = () => {
    const sections: FooterSection[] = [
      {
        title: 'Quick Links',
        links: [
          { title: 'Home', href: '/' },
          { title: 'Shop', href: '/shop' },
          { title: 'Services', href: '/services' },
        ]
      },
      {
        title: 'Help & Info',
        links: [
          { title: 'Track Your Order', href: '/track-order' },
          { title: 'Privacy Policy', href: '/help/privacy-policy' },
          { title: 'Terms & Conditions', href: '/help/terms-and-condition' },
          { title: 'Refund Policy', href: '/help/refund-policy' }
        ]
      },
    ];
  
    const socialIcons = ['facebook', 'twitter', 'youtube', 'pinterest', 'instagram'];
  
    return (
      <footer id="footer" className="mt-5">
        <Container>
          <Row className="row d-flex flex-wrap justify-content-between py-5">
            <Col md={3} sm={6}>
              <div className="footer-menu footer-menu-001">
                <div className="footer-intro mb-4">
                  <Link to="#">
                    <img src={Logo} alt="logo" style={{
                      width: '164px',
                    }} />
                  </Link>
                </div>
                <p>At Easysauces we are poised to providing our customers with tasty, mouth-watering, and delicious sauces.</p>
                <div className="social-links">
                  <ul className="list-unstyled d-flex flex-wrap gap-3">
                    {socialIcons.map(icon => (
                      <li key={icon}>
                        <Link to="#" className="text-secondary">
                          {/* <SocialIcon network={icon} /> */}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </Col>
  
            {sections.map((section, index) => (
              <div key={index} className="col-md-3 col-sm-6">
                <div className="footer-menu">
                  <h5 className="widget-title text-uppercase mb-4">{section.title}</h5>
                  <ul className="menu-list list-unstyled text-uppercase border-animation-left fs-6">
                    {section.links.map((link, linkIndex) => (
                      <li key={linkIndex} className="menu-item" style={{lineHeight: '2'}}>
                        <a href={link.href} className="item-anchor">{link.title}</a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
  
            <div className="col-md-3 col-sm-6">
              <div className="footer-menu border-animation-left">
                <h5 className="widget-title text-uppercase mb-4">Contact Us</h5>
                <p>
                  Do you have any questions or suggestions?{' '}
                  <span style={{ color: '#333' }}>info@easysauces.com</span>
                </p>
                <p>
                  Do you need support? Give us a call.{' '}
                  <Link to="tel:+2348134888223" className="item-anchor">
                    +234 705 950 8080
                  </Link>
                </p>
              </div>
            </div>
          </Row>
        </Container>
        
        <div className="border-top py-4">
          <div className="container">
            <div className="row">
              <div className="col-md-6 d-flex flex-wrap">
                <div className="shipping mx-2">
                  <span>We ship within <strong>24 - 48hrs</strong></span>
                </div>
                <div className="payment-option">
                  <span>Payment Option:</span>
                  <img src={VisaCard} alt="card" className='mx-2' />
                  <img src={MasterCard} alt="card" />
                </div>
              </div>
              <div className="col-md-6 text-end">
                <p>
                  &copy; Copyright 2022 Easysauces - All rights reserved. 
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
};
  
export default Footer;